import { Color, DefaultLoader, Engine, ExcaliburGraphicsContext, Scene, SceneActivationContext, vec } from 'excalibur';
import { resources } from '../../../../Resources';
import { controller } from '../../../../shared/controls/controller';
import { leftKeyboard } from '../../../../shared/controls/leftKeyboard';
import { rightKeyboard } from '../../../../shared/controls/rightKeyboard';
import { loadResources } from '../../../../shared/utilities/loadResources';
import { Helicopter } from '../../actors/Helicopter';
import { Terrain } from './terrain/Terrain';

export class HelicoptersScene extends Scene {
    constructor() {
        super();
        this.backgroundColor = Color.fromHex('#0069af'); // Sky blue
    }

    private terrain: Terrain | null = null;

    override onInitialize(engine: Engine): void {
        // Mountainous terrain: high noiseAmp, low smoothing, small xStep
        this.terrain = new Terrain({
            noiseAmp: 28,         // Even lower amplitude for gentle hills
            noiseSmoothing: 0.85, // High smoothing for rolling hills
            xStep: 64,            // Large step for long, smooth slopes
            bandGap: 80,
        });
        this.add(this.terrain);
    }

    override onPreLoad(loader: DefaultLoader): void {
        loadResources(loader, resources.games.helicopters.actors.helicopter);
    }

    override onPostUpdate(engine: Engine, elapsedMs: number): void {
        this._initHelicopters(engine);
    }

    private _helicoptersInitialized = false;
    private _initHelicopters(engine: Engine) {
        if (this._helicoptersInitialized) return;
        this._helicoptersInitialized = true;

        const margin = 200;
        let y = engine.drawHeight * 0.25;
        if (this.terrain && (this.terrain as any).segments && (this.terrain as any).segments.length > 0) {
            // Use first segment for y placement
            const seg = (this.terrain as any).segments[0];
            y = Math.min(seg.a.y, seg.b.y) - 30;
        }

        const usableGamepads = engine.input.gamepads.getValidGamepads();

        // First helicopter: left side of screen
        const controller1 = usableGamepads.length > 0
            ? controller(usableGamepads[0])
            : leftKeyboard(engine.input.keyboard);
        const heli1 = new Helicopter(vec(margin, y), controller1, Color.fromHex('#5cbe00'));
        this.add(heli1);

        // Second helicopter: right side of screen, facing left
        const controller2 = usableGamepads.length === 0
            ? rightKeyboard(engine.input.keyboard)
            : usableGamepads.length > 1
                ? controller(usableGamepads[1])
                : leftKeyboard(engine.input.keyboard);

        const heli2 = new Helicopter(vec(engine.drawWidth - margin, y), controller2, Color.fromHex('#ca2500'));
        (heli2 as any)._lookingRight = false;
        this.add(heli2);
    }

    override onActivate(context: SceneActivationContext<unknown>): void { }
    override onDeactivate(context: SceneActivationContext): void { }
    override onPreUpdate(engine: Engine, elapsedMs: number): void { }
    override onPreDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void { }
    override onPostDraw(ctx: ExcaliburGraphicsContext, elapsedMs: number): void { }
}
